import dataAuthorizerApi from '@innovyze/stylovyze/lib/apis/dataAuthorizer.api';
export const getS3DataAuthCookies = () => dataAuthorizerApi.get('/v1/auth');
